// 固定翼自检
export default {
    magneticCompass: 'Магнитный компас',
    airspeedMeter: 'Измеритель скорости полета',
    executiveAgency: 'Исполнительное агентство',
    missionLoad: 'Загрузка миссии',
    heading: 'Заголовок',
    calibration: 'калибровка',
    airspeed: 'скорость полета',
    cleared: 'Очищено',
    TMRA: 'Мотор по очереди вращается на холостом ходу.',
    motor: 'Мотор',
    AIOR: 'Автоматический осмотр поверхности руля направления по очереди',
    ARL: 'Крен элеронов влево',
    ARR: 'Крен элеронов вправо',
    liftingRod: 'Подъемная штанга',
    liftPushRod: 'Подъемная штанга',
    turnLeft: 'Повернуть налево',
    turnRight: 'Поверни направо',
    POSC: 'Счетчик POS в полетном контроллере',
    TAPO: 'Сделай фото один раз',
    TPTT: 'Сделай фото десять раз',
    SWTT: 'Начни ждать, чтобы сделать снимки',
    SWTTP: 'Перестань ждать, чтобы сделать фотографии',
    CPD: 'Очистить данные POS',
    tip_TMEA: 'Металлическое оборудование вокруг управления полетом / внешнего магнитного компаса переместилось или изменилось. Выполните расширенную калибровку.',
}